import { IFacetMapping } from '../models/Facet';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { readItems } from './readItems';
import { IItemCache } from '../models/IItemCacheObserver';

/**
 * Creates an action which, when dispatched, reads the current facets from an item in the cache.
 * Should only be used by data sources to make decisions about items.
 * @deprecated Use `readItems` instead.
 * @public
 */
export function readItem<TFacets extends object>(mapping: IFacetMapping<TFacets>, itemKey: string | undefined):
    IItemCacheThunkAction<Partial<TFacets>> {
    return (dispatch: IItemCacheDispatch) => {
        return dispatch(readItems((itemCache: IItemCache) => {
            return itemCache.demandItem(mapping, itemKey);
        }));
    };
}
